
import { checkOS } from "@js/utils";
class HomeHero extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        this.initMarquee()
        this.modifyTitle()
        setTimeout(() => {
            this.setup()
        }, 100);
        this.updateVideoSrc();
    }
    initMarquee() {
        if (window.innerWidth < 768) {
            const marqueeWrap = this.querySelector('.home-hero-trust-label')
            const marquee = this.querySelector('.home-hero-trust-label-inner')
            const cloneEl = marquee.cloneNode(true);
            marqueeWrap.appendChild(cloneEl);

            marqueeWrap.querySelectorAll('.home-hero-trust-label-inner').forEach((item) => {
                item.classList.add('animMarquee')
            })
        }
    }
    modifyTitle() {
        let title = this.querySelector('.home-hero-left-title .txt');
        let modifiedTitle = title.innerHTML.replace(/_(.*?)_/g, '<span class="txt-highlight">$1 </span><br>');
        title.innerHTML = modifiedTitle;
        setTimeout(() => {
            title.classList.add('show')
        }, 100);
    }
    updateVideoSrc() {
        if (checkOS().browser === 'Safari') {
            this.querySelector('.home-hero-right-machine video.home-hero-right-machine-video [data-video="webm"]').remove();
        } else {
            this.querySelector('.home-hero-right-machine video.home-hero-right-machine-video [data-video="mov"]').remove();
        }
        this.querySelector('.home-hero-right-machine video.home-hero-right-machine-video').load();
        this.querySelector('.home-hero-right-machine video.home-hero-right-machine-video').addEventListener('loadeddata', () => {
            this.querySelector('.home-hero-right-machine-img').remove();
            this.querySelector('.home-hero-right-machine video.home-hero-right-machine-video').play();
        });
    }
    setup() {
        this.tl = gsap.timeline({
            delay: .5,
            onStart: () => {
                this.querySelectorAll('[data-init-df]').forEach((el) => {el.removeAttribute('data-init-df')});
            },
        })
        new MasterTimeline({
            el: this,
            timeline: this.tl,
            tweenArr: [
                new RevealText({ el: this.querySelector('.home-hero-left-title .txt'), color: 'black', isHighlight: true, allowMobile: true }),
                new FadeIn({ el: this.querySelector('.home-hero-right-machine'), allowMobile: true }),
                new FadeIn({ el: this.querySelector('.home-hero-right-logo'), from: { y: parseRem(-50) }, delay: "<=.3", allowMobile: true }),
                ...Array.from(this.querySelectorAll('.home-hero-left-btns-btn')).map(el => {
                    return new FadeIn({ el, allowMobile: true })
                }),
                new FadeIn({ el: this.querySelector('.home-hero-trust-label') }),
                new FadeIn({ el: this.querySelector('.home-hero-trust-inner') }),
                new ScaleLine({ el: this.querySelector('.home-hero-trust .div-line') }),
            ]
        });
    }
}

customElements.define('home-hero', HomeHero);